import { useQuery } from "@tanstack/react-query";
import { TourHeader } from "@/types/dto/pdp/pdp-header-about";
import { tourHeaderFactory } from "@/factories/pdp";

export const fetchTourHeaderData = (
  packageId: string,
  packageDateId: string,
  neoId: string,
  currencyId: string,
  marketId: string,
  contentfulData?: any
) => async (): Promise<TourHeader> => {
  try {
    const url = `/api/pdp/tour-header?landingPageId=${contentfulData?.tourContent?.landingPageId}&packageId=${packageId}&packageDateId=${packageDateId}&neoId=${neoId}&currencyId=${currencyId}&marketId=${marketId}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    const rawTourHeader = await response.json();
    return tourHeaderFactory(rawTourHeader, contentfulData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error sending GET request:", error); // TODO: log error to error tracking service
    throw error;
  }
};

const useTourHeader = (
  packageId: string,
  packageDateId: string,
  neoId: string,
  currencyId: string,
  marketId: string,
  contentfulData?: any,
  enabled: boolean = true
) => useQuery<TourHeader>({
  queryKey: ["PDP_TOUR_HEADER", neoId, packageId, packageDateId, currencyId, marketId],
  queryFn: fetchTourHeaderData(packageId, packageDateId, neoId, currencyId, marketId, contentfulData),
  enabled: enabled && !!currencyId && !!marketId,
  staleTime: Infinity
});

export default useTourHeader;
